import request from "@/utils/request";
import ENDPOINT from "@/config/endpoint";

export async function fetchSubscribe(params) {
  return await request({
    url: ENDPOINT.SUBSCRIBE,
    method: "get",
    params,
  });
}
